// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-74dff2f0]{display:flex;flex-direction:column;align-items:center}.container .fast[data-v-74dff2f0]{margin-top:13.33333vw;background:#596afd;border-radius:1.6vw;color:#fff}.container .code[data-v-74dff2f0],.container .fast[data-v-74dff2f0]{width:78.66667vw;height:11.73333vw;font-size:4.26667vw}.container .code[data-v-74dff2f0]{margin-top:5.33333vw;border-radius:1.6vw;border:1px solid #e7e4e9}", ""]);
// Exports
module.exports = exports;
